






















































































































































import Vue, { PropType } from 'vue';
import { getEmailStatusConfig } from '@/helpers/stats-utils';
import EmailPreviewTooltip from '@/components/Dunning/EmailPreviewTooltip.vue';
import { CopyToClipboard } from '@/mixins/copy-to-clipboard';

export default Vue.extend({
  name: 'CampaignTable',
  components: {
    EmailPreviewTooltip,
  },
  mixins: [CopyToClipboard],
  props: {
    campaigns: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },
  data() {
    return {
      getEmailStatusConfig,
    };
  },
});
